<template>
  <div>
    <div class="flex max-w-[80rem] w-full min-h-[400px] m-auto bg-white md:rounded-xl overflow-hidden mb-20">
      <div class="hidden md:block md:w-1/2 relative">
        <img
          class="absolute object-cover w-full h-full right-0 bottom-0 top-0 left-0"
          src="@pub/images/register-background.jpg"
        />
      </div>
      <div class="w-full md:w-1/2 pt-10 p-8 md:p-16 flex justify-center items-center">
        <div class="w-full max-w-[350px]">
          <div class="flex flex-col gap-4">
            <h3 class="text-2xl font-semibold text-center">{{ $t('account.password.header') }}</h3>
            <h3 class="mb-5 text-center">{{ $t('account.password.forceChange') }}</h3>
            <FormValidator :errors="errors">
              <div class="flex flex-col gap-4">
                <FormField symbol="current_password">
                  <ZLabel>{{ $t('account.password.form.currentPassword') }}</ZLabel>
                  <ZInput v-model="form.current_password" type="password" />
                </FormField>
                <FormField symbol="password">
                  <ZLabel>{{ $t('account.password.form.password') }}</ZLabel>
                  <ZInput v-model="form.password" type="password" />
                </FormField>
                <FormField symbol="password_confirmation">
                  <ZLabel>{{ $t('account.password.form.passwordConfirmation') }}</ZLabel>
                  <ZInput v-model="form.password_confirmation" type="password" />
                </FormField>
                <ZButton @click.prevent="reset()">{{ $t('auth.resetPasswordForm.button') }}</ZButton>
                <ZButton variant="outline" @click.prevent="logout()">{{ $t('auth.resetPasswordForm.logout') }}</ZButton>
              </div>
            </FormValidator>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { postUpdatePassword } from '../../api';
import loaderStore from '../../stores/loader';
import router from '../../router';
import { ZInput } from '@shadcn/components/ui/input';
import { ZButton } from '@shadcn/components/ui/button';
import { ZLabel } from '@shadcn/components/ui/label';
import { useToast } from '@shadcn/components/ui/toast/use-toast';
import FormValidator from '../../components/FormValidator.vue';
import FormField from '../../components/FormField.vue';
import { ROUTE } from '@/router/routeNames';
import { HttpStatusCode } from 'axios';
import { ValidationErrors } from '../../types/ValidationErrors';
import useUserStore from '@/stores/auth';

export default defineComponent({
  components: {
    ZInput,
    ZButton,
    ZLabel,
    FormValidator,
    FormField,
  },

  data() {
    return {
      errors: null as null | ValidationErrors,
      form: {
        current_password: '',
        password: '',
        password_confirmation: '',
      } as App.Data.UserUpdatePasswordRequestData,
    };
  },

  methods: {
    logout() {
      const { logoutUser } = useUserStore();
      logoutUser();
    },

    reset() {
      const { toast } = useToast();
      const { startLoading, stopLoading } = loaderStore();
      startLoading();
      postUpdatePassword(this.form)
        .then(() => {
          toast({
            title: this.$t('common.success.header'),
            description: this.$t('common.success.saved'),
          });
          router.push({ name: ROUTE.DASHBOARD });
        })
        .catch(error => {
          if (error?.response?.status == HttpStatusCode.UnprocessableEntity) {
            this.errors = error.response.data.errors;
          }
        })
        .finally(() => stopLoading());
    },
  },
});
</script>
